import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import {
    GET_OVERRIDE_DETAILS_SUCCESS,
    GET_OVERRIDE_DETAILS_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getOverrideDetailsData(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = `/occ/v2/${baseSiteId}/priceOverride/details`;

    const { myCaseRef = '' } = action.payload || {};

    try {
        const response = yield axios.get(url, {
            params: { myCaseRef },
        });
        yield put({ type: GET_OVERRIDE_DETAILS_SUCCESS, data: response.data });
    } catch (error) {
        yield put({
            type: GET_OVERRIDE_DETAILS_FAILURE,
            data: errorHandler(error),
        });
        logUiErrorToBackend('getOverrideDetailsData', error);
    }
}
